var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center big-margin"},[_c('i',{staticClass:"fas fa-check fa-4x"}),_c('h1',{staticClass:"small-margin"},[_vm._v("Muchas gracias")]),_c('p',[_vm._v("Tus respuestas fueron almacenadas correctamente.")])])
}]

export { render, staticRenderFns }